<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card [title]="'turnover.required.title' | translate">
      <div left-content>
        <div *ngIf="telemarketing" class="tm">
          <p>TM</p>
        </div>
        <ng-template [ngTemplateOutlet]="turnoverBlock"></ng-template>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="turnoverBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #turnoverBlock>
  <form [formGroup]="turnoverForm">
    <div content class="content-container">
      <div class="input-container">
        <app-currency-input
          [label]="'turnover.estimatedTurnover'"
          [control]="estimatedTurnover"
          [error]="getErrors('estimatedTurnover')"
        ></app-currency-input>
      </div>
      <div class="input-container">
        <app-currency-input
          [label]="'turnover.estimatedTurnoverPrev'"
          [control]="estimatedTurnoverPrev"
          [error]="getErrors('estimatedTurnoverPrev')"
        ></app-currency-input>
      </div>
      <app-infobox
        [title]="'turnover.infobox.title' | translate"
        [content]="'turnover.infobox.content' | translate"
      >
      </app-infobox>
    </div>
    <ng-template *ngIf="!isSummary" [ngTemplateOutlet]="identifyButtonBlock"></ng-template>
  </form>
</ng-template>

<ng-template #identifyButtonBlock>
  <div actions class="navigationButtons">
    <div class="button-container">
      <app-deeplink-button
        (buttonClicked)="handleButtonClick()"
        mat-flat-button
        color="primary"
        [text]="!telemarketing 
          ? 'turnover.required.buttonText' 
          : 'turnover.telemarketing.button'"
        [fullWidth]="true"
        [icon]="!telemarketing 
        ? locale === 'nl-NL' 
        ? 'idin-icon' 
        : 'mobile-bank-id-icon' 
        : 'none'"
      ></app-deeplink-button>
    </div>
  </div>
</ng-template>